module.exports = __webpack_public_path__ + "img/八達通.2a5f4696.png";